(ns renolit-roofing-service.util.work-package)

(defn revision-task-rows
  [nodes {:poi/keys [id type parent-zone-id work-package]}]
  (let [{:keys [wp wp-type tasks]} work-package
        subzone-name (:zone/name (nodes parent-zone-id))]
    (map (fn [{:keys [task-type comment]}]
           {:wp wp
            :wp-type wp-type
            :poi-type type
            :task-type task-type
            :poi-id id
            :zone-id parent-zone-id
            :subzone-name subzone-name
            :comment comment})
         tasks)))

(defn group-tasks
  [nodes]
  (let [revisions (filter :poi/id (vals nodes))
        rows (mapcat (fn [rev]
                       (revision-task-rows nodes rev))
                     revisions)]
    (reduce (fn [acc {:keys [wp wp-type poi-type task-type

                             poi-id zone-id subzone-name comment]}]
              (update-in acc [wp wp-type poi-type task-type]
                         (fn [v]
                           (conj v {:poi-id poi-id
                                    :zone-id zone-id
                                    :subzone-name subzone-name
                                    :comment comment}))))
            {}
            rows)))
